import React, {useCallback, useEffect, useState} from 'react';

import {Group, Item} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';
import {pluralize} from '@pb/kit-formatters';

import {SidebarSection} from './sidebar-section';
import {Topic} from './topic';

import type {Notification} from 'src/openapi/admin/models/Notification';
import type {SortDirection} from 'src/openapi/admin/models/SortDirection';


type Props = {
    userTopics: string[],
    notifications: Notification[],
    dateSortDirection: SortDirection,
};

export const Topics = ({userTopics, notifications, dateSortDirection}: Props) => {
    const [expandedTopics, setExpandedTopics] = useState<string[]>([]);

    const toggleTopic = useCallback((topic: string) => {
        setExpandedTopics(prevState => {
            if (!prevState.includes(topic)) {
                return [...prevState, topic];
            } else {
                return prevState.filter(item => item !== topic);
            }
        });
    }, [setExpandedTopics]);

    useEffect(() => {
        setExpandedTopics(userTopics);
    }, [userTopics, setExpandedTopics]);

    return (
        <SidebarSection grow={true}>
            <Group gap="m" direction="v" as="nav">
                <Item className="group-item pdx-m">
                    <Typography fontWeight="semi-bold" variant="heading-level-3">
                        {pluralize(`Topic[s] (${userTopics.length})`, userTopics.length)}
                    </Typography>
                </Item>
                <Group direction="v" as="ul">
                    {userTopics.map((topic: string) => (
                        <Topic
                            key={topic}
                            topic={topic}
                            dateSortDirection={dateSortDirection}
                            notifications={notifications}
                            expandedTopics={expandedTopics}
                            onToggleTopic={toggleTopic}
                        />
                    ))}
                </Group>
            </Group>
        </SidebarSection>
    );
};
